import React from 'react';
import { iconWrapper, InjectedProps } from '../iconWrapper';

interface Props extends InjectedProps {
  className?: string;
}

class PaymentLoading extends React.PureComponent<Props> {
  public render() {
    return (
      <svg
        className={['icon-svg', 'svg-payment-loading', this.props.className].join(' ')}
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 16 16"
      >
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="white"
          strokeWidth="2"
          fill="none"
          className="spinner"
        />
      </svg>
    );
  }
}

export const icon = iconWrapper(PaymentLoading);
